export interface ISidebarCssProvider {
    getBaseCssFiles(): string[];
}
